import { P } from 'components'
import { useNavigate } from 'react-router-dom'
import { Button, Modal, ModalBody, Spinner } from 'reactstrap'

const ModalSellerRejectConfirm = ({ isOpen, toggle, onConfirm, isLoading }) => {
  const navigate = useNavigate()

  return (
    <Modal
      className="p-4"
      centered
      isOpen={isOpen}
      toggle={() => {
        toggle()
      }}
      autoFocus={false}
      data-testid="detail-transaction-modal-reject"
    >
      <ModalBody>
        <P size="medium" className="fw-semibold mb-1">
          Tolak penyesuaian
        </P>
        <P size="regular" className="text-sm mb-4" color="#475467">
          Anda yakin ingin menolak penyesuaian ini?
        </P>

        <div className="d-flex gap-3">
          <Button
            disabled={isLoading}
            onClick={() => toggle()}
            className="btn-cancel"
            outline
            block
            data-testid="detail-transaction-modal-reject-cancel"
          >
            Batal
          </Button>
          <Button
            disabled={isLoading}
            onClick={() => onConfirm()}
            color="primary"
            block
            data-testid="detail-transaction-button-reject"
          >
            {isLoading && (
              <Spinner
                className="me-1"
                size={'sm'}
                style={{ color: 'white' }}
              />
            )}{' '}
            Lanjutkan
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalSellerRejectConfirm
